const AfghanistanSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110706)">
      <path
        d="M28.6953 1.98453C26.066 0.713125 23.1161 0 19.9997 0C16.8833 0 13.9335 0.713125 11.3041 1.98453L9.56494 20L11.3041 38.0155C13.9335 39.2869 16.8833 40 19.9997 40C23.1161 40 26.066 39.2869 28.6953 38.0155L30.4345 20L28.6953 1.98453Z"
        fill="#D80027"
      />
      <path
        d="M11.3044 1.98535C4.61453 5.22027 0 12.071 0 20.0001C0 27.9293 4.61453 34.78 11.3044 38.0149V1.98535Z"
        fill="black"
      />
      <path
        d="M28.6958 1.98535V38.0149C35.3856 34.78 40.0002 27.9293 40.0002 20.0001C40.0002 12.071 35.3856 5.22027 28.6958 1.98535Z"
        fill="#496E2D"
      />
      <path
        d="M19.9999 13.043C16.1579 13.043 13.0435 16.1575 13.0435 19.9995C13.0435 23.8414 16.158 26.9559 19.9999 26.9559C23.8419 26.9559 26.9564 23.8414 26.9564 19.9995C26.9564 16.1575 23.842 13.043 19.9999 13.043ZM19.9999 24.3473C17.5987 24.3473 15.6521 22.4006 15.6521 19.9995C15.6521 17.5983 17.5988 15.6516 19.9999 15.6516C22.4011 15.6516 24.3478 17.5983 24.3478 19.9995C24.3478 22.4006 22.4012 24.3473 19.9999 24.3473Z"
        fill="#FFDA44"
      />
      <path
        d="M19.9999 17.3916C19.0393 17.3916 18.2607 18.1702 18.2607 19.1307V21.7394H21.739V19.1307C21.739 18.1702 20.9604 17.3916 19.9999 17.3916Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110706">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default AfghanistanSvg;
